import { IsOptional, IsString, MaxLength } from 'class-validator';
import { SURVEY_INVITE_REVOKE_REASON_MAX_LENGTH } from '../../types/survey-invite';
import { OptionalStringTransform } from '../../validation/optional-string.transformer';

export class RevokeSurveyInviteDto {
  @IsOptional()
  @OptionalStringTransform()
  @IsString()
  @MaxLength(SURVEY_INVITE_REVOKE_REASON_MAX_LENGTH)
  reason?: string;
}
